export enum EventCategory {
  Agent = 'Agent',
  FlowAi = 'FlowAi',
  Flows = 'Flows',
  FlowDefinition = 'FlowDefinition',
  FlowDefinitionTemplate = 'FlowDefinitionTemplate',
  FlowBatchTest = 'FlowBatchTest',
  FlowDefinitionEdit = 'FlowDefinitionEdit',
  FlowDefinitionEditContextMenu = 'FlowDefinitionEditContextMenu',
  CreateFlowDialog = 'CreateFlowDialog',
  FlowsTable = 'FlowsTable',
  SidebarNavigation = 'SidebarNavigation',
  Navigation = 'Navigation',
  BlockConfiguration = 'BlockConfiguration',
  AsyncTypeahead = 'AsyncTypeahead',
  TypeaheadList = 'TypeaheadList',
  FlowCostEstimate = 'FlowCostEstimate',
  FlowRunCost = 'FlowRunCost',
  Sidekick = 'Sidekick',
}

export enum EventAction {
  AgentCreateButtonClick = 'AgentCreateButton-Click',
  ApplyAllButtonClick = 'ApplyAllButton-Click',
  CreateButtonClick = 'CreateButton-Click',
  NewConversationButtonClick = 'NewConversationButton-Click',
  OpenButtonClick = 'OpenButton-Click',
  ResponseStreamBegin = 'ResponseStream-Begin',
  SubmitButtonClick = 'SubmitButton-Click',
  TestButtonClick = 'TestButton-Click',
  BatchTestButtonClick = 'BatchTestButton-Click',
  EditButtonClick = 'EditButton-Click',
  ViewButtonClick = 'ViewButton-Click',
  SaveButtonClick = 'SaveButton-Click',
  MoveToReviewButtonClick = 'MoveToReviewButton-Click',
  PublishButtonClick = 'PublishButton-Click',
  RunBatchTestButtonClick = 'RunBatchTestButton-Click',
  BlockCreateButtonClick = 'BlockCreateButton-Click',
  BlockAddPaste = 'BlockAdd-Paste',
  BlockAddMenuItemClick = 'BlockAddMenuItem-Click',
  BlockEdgeCreate = 'BlockEdge-Create',
  BlockDeleteKeyStroke = 'BlockDelete-KeyStroke',
  BlockDeleteButtonClick = 'BlockDeleteButton-Click',
  BlockClick = 'Block-Click',
  CardClick = 'Card-Click',
  HeroClick = 'Hero-Click',
  FilterClick = 'Filter-Click',
  SearchTerm = 'Search-Term',
  UseTemplateClick = 'UseTemplate-Click',
  FilterApplied = 'Filter-Applied',
  FilterCleared = 'Filter-Cleared',
  TableRowClick = 'TableRow-Click',
  AgentsLinkClick = 'AgentsLink-Click',
  FlowsLinkClick = 'FlowsLink-Click',
  KnowledgeBasesLinkClick = 'KnowledgeBasesLink-Click',
  ReferenceTablesLinkClick = 'ReferenceTablesLink-Click',
  RunsLinkClick = 'RunsLink-Click',
  ScenariosLinkClick = 'ScenariosLink-Click',
  CreateFlowButtonClick = 'CreateFlowButton-Click',
  ExploreTemplatesButtonClick = 'ExploreTemplatesButton-Click', // Explore templates is now named Flow Library in the UI
  OutputTabClick = 'OutputTab-Click',
  InputsTabClick = 'InputsTab-Click',
  LogsTabClick = 'LogsTab-Click',
  MetadataTabClick = 'MetadataTab-Click',
  ConfigurationTabClick = 'ConfigurationTab-Click',
  DocumentationTabClick = 'DocumentationTab-Click',
  LastTestTabClick = 'LastTestTab-Click',
  AnalyticsTabClick = 'AnalyticsTab-Click',
  /** Only used when resourceFirstArchitectureDemo flag is on */
  ResourcesTabClick = 'ResourcesTab-Click',
  ResumeFromBlockButtonClick = 'ResumeFromBlockButton-Click',
  DialogClose = 'Dialog-Close',
  VoiceAssistantsLinkClick = 'VoiceAssistantsLink-Click',
  AddBulkInput = 'BulkInput-Add',
  AddSingleInput = 'SingleInput-Add',
  ViewPricingMenuItemClick = 'ViewPricingMenuItem-Click',
  ViewFlowRunPriceMenuItemClick = 'ViewFlowRunPriceMenuItem-Click',
  // Sidekick events
  TaskClaimed = 'Task-Claimed',
  TaskCompleted = 'Task-Completed',
  AutofillStarted = 'Autofill-Started',
  AutofillCompleted = 'Autofill-Completed',
  AutofillThinkingStarted = 'AutofillThinking-Started',
  AutofillThinkingCompleted = 'AutofillThinking-Completed',
  AutofillActionFailed = 'AutofillAction-Failed',
  AutofillPageSummary = 'AutofillPage-Summary',
}
